import actions from "actions";
import FileField from "components/InputField/FileField";
import InputField from "components/InputField/InputField";
import Icon from "material-ui/Icon";
import React, { Component } from "react";
import { connect } from "react-redux";
import pdfPlaceholder from "../../assets/img/pdfPlaceholder.png";
import { ERROR_TYPE_REQUEST } from "../../constants/api";

const { createStudyGroupMaterial } = actions;

class StudyGroupUserMaterialsNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      file: null,
      file_url: "",
      fileType: "",
    };
  }

  handleFileChange = (file) => {
    if (file)
      return this.setState({
        file,
        file_url: URL.createObjectURL(file),
        fileType: file.type,
      });
    this.setState({ file: null, file_url: "", fileType: "" });
  };

  handleTitleChange = (title) => this.setState({ title });

  handleCreate = () =>
    this.props.createStudyGroupMaterial({
      title: this.state.title,
      file: this.state.file,
      group_id: this.props.params.id,
    });

  render() {
    const { errors } = this.props;

    return (
      <div style={{ width: "70%", margin: "auto" }}>
        <h3>Add new material</h3>
        <InputField
          label="Title"
          value={this.state.title}
          onChange={(e) => this.handleTitleChange(e.target.value)}
        />
        {errors && errors.title && (
          <div style={{ color: "red", fontSize: "0.875rem" }}>
            {errors.title[0]}
          </div>
        )}
        <div>
          <label
            className="mt-20 button_classic add_attachment_button"
            htmlFor="vebinar_attachment"
          >
            Add New File
          </label>
          <FileField
            className="col s12 vebinar_attachment"
            field_name="vebinar_attachment"
            onChange={(e) => this.handleFileChange(e.target.value)}
            label="File"
          />
          {this.state.file_url ? (
            <div className="attachment_preview_wrapper">
              <Icon
                onClick={() => this.handleFileChange()}
                className="remove_attachment"
              >
                close
              </Icon>
              <img
                src={
                  this.state.fileType.includes("image")
                    ? this.state.file_url
                    : pdfPlaceholder
                }
                className="attachment_preview"
              />
            </div>
          ) : null}
        </div>
        {errors && errors.file && (
          <div style={{ marginBottom: 10, color: "red", fontSize: "0.875rem" }}>
            {errors.file[0]}
          </div>
        )}
        <button className="button_classic" onClick={this.handleCreate}>
          Save
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  errors: state.errors[ERROR_TYPE_REQUEST],
});

const mapDispatchToProps = (dispatch) => ({
  createStudyGroupMaterial: (data) => dispatch(createStudyGroupMaterial(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupUserMaterialsNew);



// WEBPACK FOOTER //
// ./src/components/StudyGroupsUser/StudyGroupUserMaterialsNew.jsx